import { W as WuiDateRangeInput$1, d as defineCustomElement$1 } from './date-range-input.js';

const WuiDateRangeInput = WuiDateRangeInput$1;
const defineCustomElement = defineCustomElement$1;

export { WuiDateRangeInput, defineCustomElement };

//# sourceMappingURL=wui-date-range-input.js.map